import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const routeMap: Record<string, string> = {
  '': '首页',
  'about': '关于我们',
  'category': '分类浏览',
  'article': '内容详情',
  'movie': '电影',
  'tv': '电视剧',
  'variety': '综艺',
  'anime': '动漫',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  if (pathSegments.length === 0) return null;

  const items: BreadcrumbItem[] = [{ label: '首页', path: '/' }];

  let accumulatedPath = '';
  pathSegments.forEach((segment, index) => {
    accumulatedPath += `/${segment}`;
    const isLast = index === pathSegments.length - 1;
    const label = routeMap[segment] || decodeURIComponent(segment);
    items.push({
      label,
      path: isLast ? undefined : accumulatedPath,
    });
  });

  return (
    <nav aria-label="面包屑导航" className="w-full bg-background-100 border-b border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-500" aria-hidden="true">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-200 font-medium whitespace-nowrap" aria-current="page">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}